<template>
  <section>
    <h2>Комната 4: {{ this.$store.state.Window4.nameWindow4 }}</h2>
    <v-row>
      <v-col
        cols="12"
        sm="3"
      >
        <h3 class="text-center">{{ tulles[0].title }}</h3>
        <v-card
          class="cardTulle"
          outlined
        >
          <v-img
            v-if="kitTulles4Choosen === 'Тюль, цвет: белый'"
            :src="tulles[0].src"
            class="white--text align-end"
          />
          <v-img
            v-else
            :src="tulles[1].src"
            class="white--text align-end"
          />

          <v-card-actions class="mx-auto">
            <v-radio-group v-model.lazy="kitTulles4Choosen" class="mx-auto" @change="calcTulle4() || updateCostTulle4() || updateCostStep4Tulle4WithErker()">
              <v-radio
                :disabled="this.$store.state.Window4.nameWindow4 === 'Кухня'"
                label="Цвет: белый"
                value="Тюль, цвет: белый"
              />
            </v-radio-group>
            <v-spacer></v-spacer>
            <v-radio-group v-model.lazy="kitTulles4Choosen" class="mx-auto" @change="calcTulle4() || updateCostTulle4() || updateCostStep4Tulle4WithErker()">
              <v-radio
                :disabled="this.$store.state.Window4.nameWindow4 === 'Кухня'"
                label="Цвет: бежевый"
                value="Тюль, цвет: бежевый"
              />
            </v-radio-group>

          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <h3 class="text-center">{{ tulles[2].title }}</h3>
        <v-card
          class="cardTulle"
          outlined
        >
          <v-img
            v-if="kitTulles4Choosen === 'Рулонная штора, цвет: белый'"
            :src="tulles[2].src"
            class="white--text align-end"
          />
          <v-img
            v-else
            :src="tulles[3].src"
            class="white--text align-end"
          />

          <v-card-actions class="mx-auto">
            <v-radio-group v-model.lazy="kitTulles4Choosen" class="mx-auto" @change="calcTulle4() || updateCostTulle4() || updateCostStep4Tulle4WithErker()">
              <v-radio
                label="Цвет: белый"
                value="Рулонная штора, цвет: белый"
              />
            </v-radio-group>
            <v-spacer></v-spacer>
            <v-radio-group v-model.lazy="kitTulles4Choosen" class="mx-auto" @change="calcTulle4() || updateCostTulle4() || updateCostStep4Tulle4WithErker()">
              <v-radio
                label="Цвет: бежевый"
                value="Рулонная штора, цвет: бежевый"
              />
            </v-radio-group>

          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <h3 class="text-center">Только шторы</h3>
        <v-card
          class="cardTulle"
          outlined
        >
          <v-img
            :src="tulles[4].src"
            class="white--text align-end"
          />

          <v-card-actions class="mx-auto">
            <v-radio-group v-model.lazy="kitTulles4Choosen" class="mx-auto" @change="calcTulle4()">
              <v-radio
                label="Только шторы"
                value="Нет"
              />
            </v-radio-group>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        class="summaryCol"
        cols="12"
        sm="3"
      >
        <h2>Окно №4: {{ this.$store.state.Window4.nameWindow4 }}</h2>
        <h3 class="pt-5">Вы выбрали:</h3>
        <ul class="pt-5">
          <li v-if="this.$store.state.Window4.windowTypeSelected4"><span><b>Тип окна:</b></span> {{ this.$store.state.Window4.windowTypeSelected4 }}</li>
          <li v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4"><span><b>Размер стены:</b></span> <span v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4">{{ this.$store.state.Window4.widthWindow4 }}</span><span v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4">*</span>{{ this.$store.state.Window4.heightWindow4 }}</li>
          <li v-if="this.$store.state.Curtains.modelCurtain4 "><b>Комплект штор: </b> {{ this.$store.state.Curtains.modelCurtain4 }}</li>
          <li v-if="kitTulles4Choosen"><b>Тюль/рулонная штора: </b>{{ kitTulles4Choosen }}</li>
          <li v-if="costTulle4"><b>Стоимость: {{ costTulle4 }} руб.</b></li>
        </ul>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'kitTulle4',
  data () {
    return {
    }
  },
  computed: {
    kitTulles4Choosen: {
      get () {
        return this.$store.state.Tulles.kitTulles4Choosen
      },
      set (value) {
        this.$store.commit('updateTulles4', value)
      }
    },
    tulles: {
      get () {
        return this.$store.state.Tulles.tulles
      }
    },
    costTulle4: {
      get () {
        return this.$store.state.Tulles.costTulle4
      }
    }
  },
  methods: {
    calcTulle4 () { // рассчет только тюли
      this.$store.commit('updateCostTulle4')
    },
    updateCostTulle4 () { // рассчет тюли от ширины
      this.$store.commit('updateCostStep4Tulle4')
    },
    updateCostStep4Tulle4WithErker () {
      this.$store.commit('updateCostStep4Tulle4WithErker')
    }
  }
}
</script>

<style>
.cardTulle {
  min-height: 343px;
}
</style>
